




















import { Component, Vue, Prop } from 'vue-property-decorator';

class CombinationStockItem {
    productNo: string = '';
    count: number = 1;
}

@Component
export default class CombinationProductModal extends Vue {
    @Prop({ type: Boolean, default: false }) value: boolean;

    combinationItems: CombinationStockItem[] = [];

    // 处理产品编号输入
    handleProductNoInput(index: number, value: string) {
        this.combinationItems[index].productNo = value;
    }

    // 处理数量变化
    handleCountChange(index: number, value: number) {
        this.combinationItems[index].count = value;
    }

    // 表格列定义
    get columns() {
        return [
            {
                title: '产品编号',
                key: 'productNo',
                minWidth: 200,
                render: (h: any, params: any) => {
                    return h('Input', {
                        props: {
                            value: params.row.productNo, // 改为小写
                            placeholder: '请输入产品编号'
                        },
                        on: {
                            input: (value: string) => {
                                this.handleProductNoInput(params.index, value);
                            }
                        }
                    });
                }
            },
            {
                title: '数量',
                key: 'count',
                width: 120,
                align: 'center',
                render: (h: any, params: any) => {
                    return h('InputNumber', {
                        props: {
                            value: params.row.count, // 改为小写
                            min: 1
                        },
                        style: {
                            width: '100%'
                        },
                        on: {
                            'on-change': (value: number) => {
                                this.handleCountChange(params.index, value);
                            }
                        }
                    });
                }
            },
            {
                title: '操作',
                width: 100,
                align: 'center',
                render: (h: any, params: any) => {
                    return h('Button', {
                        props: {
                            type: 'error',
                            size: 'small'
                        },
                        on: {
                            click: () => {
                                this.removeRow(params.index);
                            }
                        }
                    }, '删除');
                }
            }
        ];
    }

    // 添加新行
    addRow() {
        this.combinationItems.push(new CombinationStockItem());
    }

    // 删除行
    removeRow(index: number) {
        this.$Modal.confirm({
            title: '确认删除',
            content: '您确定要删除这个产品吗？',
            onOk: () => {
                this.combinationItems.splice(index, 1);
            }
        });
    }

    // 保存
    async save() {
        // 验证数据
        const invalidItems = this.combinationItems.filter(item =>
            !item.productNo || item.count < 1
        );

        if (invalidItems.length > 0) {
            this.$Message.error('请填写完整的产品信息');
            return;
        }

        await this.$store.dispatch({
            type: 'frontstockproduct/EditCombinationStock',
            data: {
                Id: this.$store.state.frontstockproduct.id,
                Item: this.combinationItems
            }
        });

        this.$Message.success('保存成功');
        this.$emit('save-success');
        this.$emit('input', false);
    }

    // 取消
    cancel() {
        this.$emit('input', false);
    }

    // 模态框显示状态变化
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
            // 初始化数据
            const rawItems = this.$store.state.frontstockproduct.combinationItems;

            if (Array.isArray(rawItems) && rawItems.length > 0) {
                this.combinationItems = rawItems.map(item => {
                    const newItem = new CombinationStockItem();

                    // 处理可能的大小写不一致问题
                    if (item) {
                        // 检查各种可能的字段名
                        newItem.productNo = item.productNo || item.ProductNo || '';
                        newItem.count = typeof (item.count || item.Count) === 'number' ?
                            (item.count || item.Count) : 1;
                    }

                    return newItem;
                });
            } else {
                this.combinationItems = [new CombinationStockItem()];
            }
        }
    }
}
